import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const API_URL = getBaseUrl('/futures/');

export async function getFuturesKeysStatus() {
    return await appRequest.doGetRequest(`${API_URL}keys`);
}

export async function saveFuturesKeys(keys) {
    return await appRequest.doPutRequest(`${API_URL}keys`, keys);
}

export async function getFuturesAccount(environment = 'test') {
    return await appRequest.doGetRequest(`${API_URL}account?environment=${environment}`);
}

export async function placeFuturesOrder(order) {
    return await appRequest.doPostRequest(`${API_URL}order`, order);
}

export async function cancelFuturesOrder(symbol, orderId, environment = 'test') {
    return await appRequest.doDeleteRequest(`${API_URL}${symbol}/${orderId}?environment=${environment}`);
}
